import { useState } from 'react';

type IProdGiftsInstance = {
    giftsPopupVisible: boolean;
    openGiftsPopup: () => void;
    closeGiftsPopup: () => void;

    quickViewVisible: boolean;
    quickViewVariantId: string;
    openQuickView: (variantId: string) => void;
    closeQuickView: () => void;
};

export function useProdGifts(): IProdGiftsInstance {
    const [giftsPopupVisible, setGiftsPopupVisible] = useState<boolean>(false);
    const [quickViewVisible, setQuickViewVisible] = useState<boolean>(false);
    const [quickViewVariantId, setQuickViewVariantId] = useState<string>('');

    return {
        giftsPopupVisible,
        openGiftsPopup: () => setGiftsPopupVisible(true),
        closeGiftsPopup: () => setGiftsPopupVisible(false),

        quickViewVisible,
        quickViewVariantId,
        openQuickView: (variantId: string) => {
            setQuickViewVariantId(variantId);
            setQuickViewVisible(true);
        },
        closeQuickView: () => setQuickViewVisible(false),
    };

}